import { render, staticRenderFns } from "./BreakdownTable.vue?vue&type=template&id=2ee991a8&scoped=true"
import script from "./BreakdownTable.vue?vue&type=script&lang=js"
export * from "./BreakdownTable.vue?vue&type=script&lang=js"
import style0 from "./BreakdownTable.vue?vue&type=style&index=0&id=2ee991a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee991a8",
  null
  
)

export default component.exports